module.exports = __webpack_public_path__ + "img/gift.efbc0a7.webp";